import { createVNode, render } from 'vue'
import Tip from './src/tip.vue'
import { SFCWithInstall, withInstall, generateUUID, removeElement } from '@touchvue/utils'
const ToTip: SFCWithInstall<typeof Tip> = withInstall(Tip)
export * from './src/instance'

interface TipOptions {
	icon?: string
	content?: string
	color?: string
	opDisplay?: string
	mode?: string
	position?: string
	during?: string | number
	closable?: boolean
	deletable?: boolean
	showIcon?: boolean
	className?: string
	[key: string]: any
}

//创建tip实例的函数
function createTipInstance(app: any, ...args: any[]): Promise<boolean> {
	if (args.length === 0) return Promise.reject('无效的 tip 内容')

	return new Promise(resolve => {
		const defaultOptions: TipOptions = {
			icon: 'info',
			content: '',
			color: 'default',
			opDisplay: 'hover',
			mode: '',
			position: 'top',
			during: 3000,
			closable: true,
			deletable: false,
			className: '',
			showIcon: true
		}
		let options: TipOptions = { ...defaultOptions }
		if (args.length === 1) {
			if (typeof args[0] === 'string') {
				options = { ...defaultOptions, content: String(args[0]) }
			}
		}
		if (args.length === 2) {
			if (typeof args[1] === 'object') {
				options = { ...defaultOptions, ...args[1], color: args[0] }
			} else {
				let icon: string = ''
				switch (args[0]) {
					case 'success': {
						icon = 'ok'
						break
					}
					case 'error': {
						icon = 'error'
						break
					}
					case 'danger': {
						icon = 'error'
						break
					}
					case 'warning': {
						icon = 'error'
						break
					}
					case 'info': {
						icon = 'info'
						break
					}
					case 'fg': {
						icon = 'error'
						break
					}
					default:
					case 'primary': {
						icon = 'error'
						break
					}
				}
				options = { ...defaultOptions, color: args[0], icon, content: String(args[1]) }
			}
		} else if (args.length === 3) {
			options = { ...options, content: String(args[0]), color: args[1], ...args[2] }
		}

		const body = document.body
		const uuid = `tip-${generateUUID()}`
		const container = document.createElement('div')
		container.setAttribute('id', uuid)
		body.appendChild(container)

		const vnode = createVNode(Tip, {
			...options,
			onClose: () => {
				setTimeout(() => {
					render(null, container)
					removeElement(container)
					resolve(true)
				}, 200)
			}
		})

		if (app && app._context) {
			vnode.appContext = app._context
		}

		render(vnode, container)

		requestAnimationFrame(() => {
			const componentInstance = vnode.component
			if (componentInstance && componentInstance.exposed && typeof componentInstance.exposed.open === 'function') {
				componentInstance.exposed.open()
			}
		})
	})
}

function createTipFunction(app: any) {
	const tipFn = function (...args: any): Promise<boolean> {
		return createTipInstance(app, ...args)
	}
	const tip = function (options: TipOptions | string): Promise<boolean> {
		return tipFn(options)
	}
	tip.success = function (options: TipOptions | string): Promise<boolean> {
		return tipFn('success', options)
	}
	tip.error = function (options: TipOptions | string): Promise<boolean> {
		return tipFn('error', options)
	}
	tip.info = function (options: TipOptions | string): Promise<boolean> {
		return tipFn('info', options)
	}
	tip.warning = function (options: TipOptions | string): Promise<boolean> {
		return tipFn('warning', options)
	}
	tip.danger = function (options: TipOptions | string): Promise<boolean> {
		return tipFn('danger', options)
	}
	tip.fg = function (options: TipOptions | string): Promise<boolean> {
		return tipFn('fg', options)
	}
	tip.toast = function (options: TipOptions | string): Promise<boolean> {
		if (typeof options === 'object') {
			options.position = options.position || 'center'
		} else {
			return tipFn(options, 'fg', {
				position: 'center'
			})
		}
		return tipFn('fg', options)
	}
	return tip
}

export const $tip = createTipFunction(null)
const originInstall = ToTip.install
ToTip.install = app => {
	originInstall(app)
	const tip = createTipFunction(app)
	app.config.globalProperties.$tip = tip
}
export default $tip
export { ToTip }
